<div class="frame-in">

  @if (userInfo) {
    <div [ngClass]="{'hidden': loading}">
      <div class="profile">
        @if (!userInfo.school || userInfo.school == 'unset') {
          <button type="button" class="parents-button" (click)="openLogin()"></button>
        }
        <button type="button" class="leave-button" (click)="previousState()"></button>
        <div class="profile-data">
          <div class="avatar">
            <img [src]="'assets/images/profile/avatars/'+ userInfo.avatar + '.png'" alt="{{userInfo.name}}">
            <button type="button" class="edit" [routerLink]="['/game/set-avatar']"></button>
          </div>
          @if (userInfo && userInfo.school && userInfo.school != 'unset') {
            <div class="user-data5">
              <ul>
                <li class="profile-school-name">{{userInfo.name}}</li>
                <li class="profile-school-name">{{schoolName}}</li>
                <li>{{userInfo.totalScore}}</li>
              </ul>
            </div>
          }
          @if (!userInfo.school || userInfo.school == 'unset') {
            <div class="user-data">
              <ul>
                <li class="profile-school-name">{{userInfo.name}}</li>
                <li class="profile-school-name">{{userInfo.age}}</li>
                <li>{{userInfo.country?userInfo.country:''}}</li>
                <li>{{userInfo.totalScore}}</li>
              </ul>
            </div>
          }
        </div>
        <div class="action-buttons">
          @if (userInfo.role == 'student') {
            <button style="width: 34%; height: 81px" type="button"  class="assignment" [routerLink]="[ '/game/my-assignments' ]"></button>
          }
          <button type="button" class="awards" [routerLink]="[ '/game/my-awards' ]"></button>
          <button type="button" class="gallery" [routerLink]="[ '/game/my-gallery' ]"></button>
        </div>
      </div>
      @if (userInfo && userInfo.school && userInfo.school != 'unset') {
        <img class="frame-bg" src="assets/images/profile/bg-school.png" (loadeddata)="instructionLoaded()">
      }
      @if (!userInfo.school || userInfo.school == 'unset') {
        <img class="frame-bg" src="assets/images/profile/bg.jpg" (loadeddata)="instructionLoaded()">
      }
    </div>
  }
</div>
